<template>
<div class="login container">

  <form id="loginform" class="form-horizontal" role="form" @submit.prevent="doLogin">
    <div style="margin-bottom: 25px; max-width: 200px;" class="form-group">
      <label for="username">{{$t('mobile')}}</label>
      <input id="login-mobile" type="text" class="form-control" name="mobile" value="" v-model='mobile'>
    </div>
    <div style="margin-bottom: 25px; max-width: 200px;" class="form-group">
      <label for="username">{{$t('password')}}</label>
      <input id="login-password" type="password" class="form-control" name="password" value="" v-model='password'>
    </div>
    <div style="margin-top:10px; text-align: right;" class="form-group">
      <input type='submit' id="btn-login" href="#" class="btn btn-success" v-bind:value="enter">
    </div>
  </form>
</div>
</template>

<script>
import Vue from 'vue'
export default {
  data() {
    return {
      mobile: '',
      password: '',
      errors: [],
      enter: this.$t('enter')
    }
  },
  computed: {
    // ...mapGetters({
    //     access_token: 'accessToken'
    // })
  },
  created() {
    console.log(this.$ls.get('access_token'))
  },
  methods: {
    doLogin: function() {
      console.log('Logging in..')
      this.$axios
        .post(`/api/sign_in`, {
          mobile: this.mobile,
          password: this.password
        })
        .then(response => {
          console.log(response.data)
          this.$ls.set('access_token', response.data.jwt)
          // this.$ls.set('logged_in_as', response.data.logged_in_as)
          // this.$ls.set('institute_name', response.data.institute_name)
          // this.$ls.set('user_name', response.data.user_name)
          // this.$ls.set('expires_at', response.data.expires_at)
          // this.$ls.set('agent', response.data.agent)
          // this.$ls.set('auth', 1)
          console.log(this.$ls.get('access_token'))
          /*
                      this.flash({
                          message: 'נכנסת בהצלחה',
                          variant: 'success'
                      });
  */

          this.$router.push('/docs/orders')
          this.$router.go()
        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  }
}
</script>